import { useInView } from "react-intersection-observer";

export default function Info() {
    const { ref, inView } = useInView({
        triggerOnce: true, // Анимация срабатывает только один раз
        threshold: 0.7, // Срабатывание анимации, когда 70% элемента видно
    });


    return (
        <div className={`relative w-full bg-white`} >
            <div className={`w-[94%] lg:w-[80%] mx-auto relative`} >
                <h1 className="text-[27px] lg:text-[42px] 2xl:text-[50px] text-[#273167] font-bold mt-4 lg:mt-7">О нас</h1>
                <div 
                className={`mt-2 lg:mt-8 flex flex-col-reverse items-center gap-5 lg:gap-0 lg:flex-row relative w-full lg:w-auto mx-auto rounded-[25px] lg:rounded-[65px] 2xl:rounded-[80px] transition-all duration-[1500ms] ${inView ? "opacity-100 translate-y-0" : "opacity-0 -translate-y-16"}`}
                ref={ref}
                >
                    <img src="/title/team.webp" alt="" className="aspect-[4/3]  w-[60%] lg:w-[45%] rounded-md lg:rounded-xl" />
                    <div className="w-full lg:ml-14 2xl:ml-16 self-start lg:-mt-3">
                        <p className="text-2xl lg:text-[42px] 2xl:text-[50px] text-[#273167] font-medium lg:font-semibold font-play leading-tight mr-1 lg:mr-2 mb-2 lg:mb-4">Turtton - <br /> это <span className="text-[#38D548]">стремление</span></p>
                        <div className="">
                            <p className="text-[12px] lg:text-[20px] 2xl:text-[25px] text-[#273167] font-medium leading-tight lg:leading-snug lg:w-[100%]">
                                Мы разрабатываем электронные устройства, ПО, сервисы и оптимизируем решения, помогая нашим клиентам достигать целей. <span><br /></span>
                                Берём на себя все этапы реализации проекта: анализ и составление требований, разработка, тестирование, запуск в производство и монтаж.
                                <br /> Гибкие условия сотрудничества.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}